import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
          options: {
            customProperties: true,
          },
        themes: {
          light: {
            primary: '#5f5b5c',//'#ee44aa',
            secondary: '#92d2c4', //'#424242',
            accent: '#82B1FF',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107'
          },
        },
      },
      icons: {
        iconfont: 'mdi',
      },
});
